/**
 * https://gist.github.com/brenes/1095110
 * @returns JSON with every dial code and it's country's name in both english and spanish
 */
const countries = () => [
	{
		es: 'Afganistán',
		en: 'Afghanistan',
		fr: 'Afghanistan',
		iso2: 'AF',
		iso3: 'AFG',
		dialCode: '93'
	},
	{
		es: 'Albania',
		en: 'Albania',
		fr: 'Albanie',
		iso2: 'AL',
		iso3: 'ALB',
		dialCode: '355'
	},
	{
		es: 'Alemania',
		en: 'Germany',
		fr: 'Allemagne',
		iso2: 'DE',
		iso3: 'DEU',
		dialCode: '49'
	},
	{
		es: 'Algeria',
		en: 'Algeria',
		fr: 'Algérie',
		iso2: 'DZ',
		iso3: 'DZA',
		dialCode: '213'
	},
	{
		es: 'Andorra',
		en: 'Andorra',
		fr: 'Andorra',
		iso2: 'AD',
		iso3: 'AND',
		dialCode: '376'
	},
	{
		es: 'Angola',
		en: 'Angola',
		fr: 'Angola',
		iso2: 'AO',
		iso3: 'AGO',
		dialCode: '244'
	},
	{
		es: 'Anguila',
		en: 'Anguilla',
		fr: 'Anguilla',
		iso2: 'AI',
		iso3: 'AIA',
		dialCode: '1264'
	},
	{
		es: 'Antártida',
		en: 'Antarctica',
		fr: "L'Antarctique",
		iso2: 'AQ',
		iso3: 'ATA',
		dialCode: '672'
	},
	{
		es: 'Antigua y Barbuda',
		en: 'Antigua and Barbuda',
		fr: 'Antigua et Barbuda',
		iso2: 'AG',
		iso3: 'ATG',
		dialCode: '1268'
	},
	{
		es: 'Antillas Neerlandesas',
		en: 'Netherlands Antilles',
		fr: 'Antilles Néerlandaises',
		iso2: 'AN',
		iso3: 'ANT',
		dialCode: '599'
	},
	{
		es: 'Arabia Saudita',
		en: 'Saudi Arabia',
		fr: 'Arabie Saoudite',
		iso2: 'SA',
		iso3: 'SAU',
		dialCode: '966'
	},
	{
		es: 'Argentina',
		en: 'Argentina',
		fr: 'Argentine',
		iso2: 'AR',
		iso3: 'ARG',
		dialCode: '54'
	},
	{
		es: 'Armenia',
		en: 'Armenia',
		fr: "L'Arménie",
		iso2: 'AM',
		iso3: 'ARM',
		dialCode: '374'
	},
	{
		es: 'Aruba',
		en: 'Aruba',
		fr: 'Aruba',
		iso2: 'AW',
		iso3: 'ABW',
		dialCode: '297'
	},
	{
		es: 'Australia',
		en: 'Australia',
		fr: 'Australie',
		iso2: 'AU',
		iso3: 'AUS',
		dialCode: '61'
	},
	{
		es: 'Austria',
		en: 'Austria',
		fr: 'Autriche',
		iso2: 'AT',
		iso3: 'AUT',
		dialCode: '43'
	},
	{
		es: 'Azerbayán',
		en: 'Azerbaijan',
		fr: "L'Azerbaïdjan",
		iso2: 'AZ',
		iso3: 'AZE',
		dialCode: '994'
	},
	{
		es: 'Bélgica',
		en: 'Belgium',
		fr: 'Belgique',
		iso2: 'BE',
		iso3: 'BEL',
		dialCode: '32'
	},
	{
		es: 'Bahamas',
		en: 'Bahamas',
		fr: 'Bahamas',
		iso2: 'BS',
		iso3: 'BHS',
		dialCode: '1242'
	},
	{
		es: 'Bahrein',
		en: 'Bahrain',
		fr: 'Bahreïn',
		iso2: 'BH',
		iso3: 'BHR',
		dialCode: '973'
	},
	{
		es: 'Bangladesh',
		en: 'Bangladesh',
		fr: 'Bangladesh',
		iso2: 'BD',
		iso3: 'BGD',
		dialCode: '880'
	},
	{
		es: 'Barbados',
		en: 'Barbados',
		fr: 'Barbade',
		iso2: 'BB',
		iso3: 'BRB',
		dialCode: '1246'
	},
	{
		es: 'Belice',
		en: 'Belize',
		fr: 'Belize',
		iso2: 'BZ',
		iso3: 'BLZ',
		dialCode: '501'
	},
	{
		es: 'Benín',
		en: 'Benin',
		fr: 'Bénin',
		iso2: 'BJ',
		iso3: 'BEN',
		dialCode: '229'
	},
	{
		es: 'Bhután',
		en: 'Bhutan',
		fr: 'Le Bhoutan',
		iso2: 'BT',
		iso3: 'BTN',
		dialCode: '975'
	},
	{
		es: 'Bielorrusia',
		en: 'Belarus',
		fr: 'Biélorussie',
		iso2: 'BY',
		iso3: 'BLR',
		dialCode: '375'
	},
	{
		es: 'Birmania',
		en: 'Myanmar',
		fr: 'Myanmar',
		iso2: 'MM',
		iso3: 'MMR',
		dialCode: '95'
	},
	{
		es: 'Bolivia',
		en: 'Bolivia',
		fr: 'Bolivie',
		iso2: 'BO',
		iso3: 'BOL',
		dialCode: '591'
	},
	{
		es: 'Bosnia y Herzegovina',
		en: 'Bosnia and Herzegovina',
		fr: 'Bosnie-Herzégovine',
		iso2: 'BA',
		iso3: 'BIH',
		dialCode: '387'
	},
	{
		es: 'Botsuana',
		en: 'Botswana',
		fr: 'Botswana',
		iso2: 'BW',
		iso3: 'BWA',
		dialCode: '267'
	},
	{
		es: 'Brasil',
		en: 'Brazil',
		fr: 'Brésil',
		iso2: 'BR',
		iso3: 'BRA',
		dialCode: '55'
	},
	{
		es: 'Brunéi',
		en: 'Brunei',
		fr: 'Brunei',
		iso2: 'BN',
		iso3: 'BRN',
		dialCode: '673'
	},
	{
		es: 'Bulgaria',
		en: 'Bulgaria',
		fr: 'Bulgarie',
		iso2: 'BG',
		iso3: 'BGR',
		dialCode: '359'
	},
	{
		es: 'Burkina Faso',
		en: 'Burkina Faso',
		fr: 'Burkina Faso',
		iso2: 'BF',
		iso3: 'BFA',
		dialCode: '226'
	},
	{
		es: 'Burundi',
		en: 'Burundi',
		fr: 'Burundi',
		iso2: 'BI',
		iso3: 'BDI',
		dialCode: '257'
	},
	{
		es: 'Cabo Verde',
		en: 'Cape Verde',
		fr: 'Cap-Vert',
		iso2: 'CV',
		iso3: 'CPV',
		dialCode: '238'
	},
	{
		es: 'Camboya',
		en: 'Cambodia',
		fr: 'Cambodge',
		iso2: 'KH',
		iso3: 'KHM',
		dialCode: '855'
	},
	{
		es: 'Camerún',
		en: 'Cameroon',
		fr: 'Cameroun',
		iso2: 'CM',
		iso3: 'CMR',
		dialCode: '237'
	},
	{
		es: 'Canadá',
		en: 'Canada',
		fr: 'Canada',
		iso2: 'CA',
		iso3: 'CAN',
		dialCode: '1'
	},
	{
		es: 'Chad',
		en: 'Chad',
		fr: 'Tchad',
		iso2: 'TD',
		iso3: 'TCD',
		dialCode: '235'
	},
	{
		es: 'Chile',
		en: 'Chile',
		fr: 'Chili',
		iso2: 'CL',
		iso3: 'CHL',
		dialCode: '56'
	},
	{
		es: 'China',
		en: 'China',
		fr: 'Chine',
		iso2: 'CN',
		iso3: 'CHN',
		dialCode: '86'
	},
	{
		es: 'Chipre',
		en: 'Cyprus',
		fr: 'Chypre',
		iso2: 'CY',
		iso3: 'CYP',
		dialCode: '357'
	},
	{
		es: 'Ciudad del Vaticano',
		en: 'Vatican City State',
		fr: 'Cité du Vatican',
		iso2: 'VA',
		iso3: 'VAT',
		dialCode: '39'
	},
	{
		es: 'Colombia',
		en: 'Colombia',
		fr: 'Colombie',
		iso2: 'CO',
		iso3: 'COL',
		dialCode: '57'
	},
	{
		es: 'Comoras',
		en: 'Comoros',
		fr: 'Comores',
		iso2: 'KM',
		iso3: 'COM',
		dialCode: '269'
	},
	{
		es: 'Congo',
		en: 'Congo',
		fr: 'Congo',
		iso2: 'CG',
		iso3: 'COG',
		dialCode: '242'
	},
	{
		es: 'Congo',
		en: 'Congo',
		fr: 'Congo',
		iso2: 'CD',
		iso3: 'COD',
		dialCode: '243'
	},
	{
		es: 'Corea del Norte',
		en: 'North Korea',
		fr: 'Corée du Nord',
		iso2: 'KP',
		iso3: 'PRK',
		dialCode: '850'
	},
	{
		es: 'Corea del Sur',
		en: 'South Korea',
		fr: 'Corée du Sud',
		iso2: 'KR',
		iso3: 'KOR',
		dialCode: '82'
	},
	{
		es: 'Costa de Marfil',
		en: 'Ivory Coast',
		fr: "Côte-d'Ivoire",
		iso2: 'CI',
		iso3: 'CIV',
		dialCode: '225'
	},
	{
		es: 'Costa Rica',
		en: 'Costa Rica',
		fr: 'Costa Rica',
		iso2: 'CR',
		iso3: 'CRI',
		dialCode: '506'
	},
	{
		es: 'Croacia',
		en: 'Croatia',
		fr: 'Croatie',
		iso2: 'HR',
		iso3: 'HRV',
		dialCode: '385'
	},
	{
		es: 'Cuba',
		en: 'Cuba',
		fr: 'Cuba',
		iso2: 'CU',
		iso3: 'CUB',
		dialCode: '53'
	},
	{
		es: 'Dinamarca',
		en: 'Denmark',
		fr: 'Danemark',
		iso2: 'DK',
		iso3: 'DNK',
		dialCode: '45'
	},
	{
		es: 'Dominica',
		en: 'Dominica',
		fr: 'Dominique',
		iso2: 'DM',
		iso3: 'DMA',
		dialCode: '1767'
	},
	{
		es: 'Ecuador',
		en: 'Ecuador',
		fr: 'Equateur',
		iso2: 'EC',
		iso3: 'ECU',
		dialCode: '593'
	},
	{
		es: 'Egipto',
		en: 'Egypt',
		fr: 'Egypte',
		iso2: 'EG',
		iso3: 'EGY',
		dialCode: '20'
	},
	{
		es: 'El Salvador',
		en: 'El Salvador',
		fr: 'El Salvador',
		iso2: 'SV',
		iso3: 'SLV',
		dialCode: '503'
	},
	{
		es: 'Emiratos Árabes Unidos',
		en: 'United Arab Emirates',
		fr: 'Emirats Arabes Unis',
		iso2: 'AE',
		iso3: 'ARE',
		dialCode: '971'
	},
	{
		es: 'Eritrea',
		en: 'Eritrea',
		fr: 'Erythrée',
		iso2: 'ER',
		iso3: 'ERI',
		dialCode: '291'
	},
	{
		es: 'Eslovaquia',
		en: 'Slovakia',
		fr: 'Slovaquie',
		iso2: 'SK',
		iso3: 'SVK',
		dialCode: '421'
	},
	{
		es: 'Eslovenia',
		en: 'Slovenia',
		fr: 'Slovénie',
		iso2: 'SI',
		iso3: 'SVN',
		dialCode: '386'
	},
	{
		es: 'España',
		en: 'Spain',
		fr: 'Espagne',
		iso2: 'ES',
		iso3: 'ESP',
		dialCode: '34'
	},
	{
		es: 'Estados Unidos de América',
		en: 'United States of America',
		fr: "États-Unis d'Amérique",
		iso2: 'US',
		iso3: 'USA',
		dialCode: '1'
	},
	{
		es: 'Estonia',
		en: 'Estonia',
		fr: "L'Estonie",
		iso2: 'EE',
		iso3: 'EST',
		dialCode: '372'
	},
	{
		es: 'Etiopía',
		en: 'Ethiopia',
		fr: 'Ethiopie',
		iso2: 'ET',
		iso3: 'ETH',
		dialCode: '251'
	},
	{
		es: 'Filipinas',
		en: 'Philippines',
		fr: 'Philippines',
		iso2: 'PH',
		iso3: 'PHL',
		dialCode: '63'
	},
	{
		es: 'Finlandia',
		en: 'Finland',
		fr: 'Finlande',
		iso2: 'FI',
		iso3: 'FIN',
		dialCode: '358'
	},
	{
		es: 'Fiyi',
		en: 'Fiji',
		fr: 'Fidji',
		iso2: 'FJ',
		iso3: 'FJI',
		dialCode: '679'
	},
	{
		es: 'Francia',
		en: 'France',
		fr: 'France',
		iso2: 'FR',
		iso3: 'FRA',
		dialCode: '33'
	},
	{
		es: 'Gabón',
		en: 'Gabon',
		fr: 'Gabon',
		iso2: 'GA',
		iso3: 'GAB',
		dialCode: '241'
	},
	{
		es: 'Gambia',
		en: 'Gambia',
		fr: 'Gambie',
		iso2: 'GM',
		iso3: 'GMB',
		dialCode: '220'
	},
	{
		es: 'Georgia',
		en: 'Georgia',
		fr: 'Géorgie',
		iso2: 'GE',
		iso3: 'GEO',
		dialCode: '995'
	},
	{
		es: 'Ghana',
		en: 'Ghana',
		fr: 'Ghana',
		iso2: 'GH',
		iso3: 'GHA',
		dialCode: '233'
	},
	{
		es: 'Gibraltar',
		en: 'Gibraltar',
		fr: 'Gibraltar',
		iso2: 'GI',
		iso3: 'GIB',
		dialCode: '350'
	},
	{
		es: 'Granada',
		en: 'Grenada',
		fr: 'Grenade',
		iso2: 'GD',
		iso3: 'GRD',
		dialCode: '1473'
	},
	{
		es: 'Grecia',
		en: 'Greece',
		fr: 'Grèce',
		iso2: 'GR',
		iso3: 'GRC',
		dialCode: '30'
	},
	{
		es: 'Groenlandia',
		en: 'Greenland',
		fr: 'Groenland',
		iso2: 'GL',
		iso3: 'GRL',
		dialCode: '299'
	},
	{
		es: 'Guadalupe',
		en: 'Guadeloupe',
		fr: 'Guadeloupe',
		iso2: 'GP',
		iso3: 'GLP',
		dialCode: '590'
	},
	{
		es: 'Guam',
		en: 'Guam',
		fr: 'Guam',
		iso2: 'GU',
		iso3: 'GUM',
		dialCode: '1671'
	},
	{
		es: 'Guatemala',
		en: 'Guatemala',
		fr: 'Guatemala',
		iso2: 'GT',
		iso3: 'GTM',
		dialCode: '502'
	},
	{
		es: 'Guayana Francesa',
		en: 'French Guiana',
		fr: 'Guyane française',
		iso2: 'GF',
		iso3: 'GUF',
		dialCode: '594'
	},
	{
		es: 'Guernsey',
		en: 'Guernsey',
		fr: 'Guernesey',
		iso2: 'GG',
		iso3: 'GGY',
		dialCode: '44'
	},
	{
		es: 'Guinea',
		en: 'Guinea',
		fr: 'Guinée',
		iso2: 'GN',
		iso3: 'GIN',
		dialCode: '224'
	},
	{
		es: 'Guinea Ecuatorial',
		en: 'Equatorial Guinea',
		fr: 'Guinée Equatoriale',
		iso2: 'GQ',
		iso3: 'GNQ',
		dialCode: '240'
	},
	{
		es: 'Guinea-Bissau',
		en: 'Guinea-Bissau',
		fr: 'Guinée-Bissau',
		iso2: 'GW',
		iso3: 'GNB',
		dialCode: '245'
	},
	{
		es: 'Guyana',
		en: 'Guyana',
		fr: 'Guyane',
		iso2: 'GY',
		iso3: 'GUY',
		dialCode: '592'
	},
	{
		es: 'Haití',
		en: 'Haiti',
		fr: 'Haïti',
		iso2: 'HT',
		iso3: 'HTI',
		dialCode: '509'
	},
	{
		es: 'Honduras',
		en: 'Honduras',
		fr: 'Honduras',
		iso2: 'HN',
		iso3: 'HND',
		dialCode: '504'
	},
	{
		es: 'Hong kong',
		en: 'Hong Kong',
		fr: 'Hong Kong',
		iso2: 'HK',
		iso3: 'HKG',
		dialCode: '852'
	},
	{
		es: 'Hungría',
		en: 'Hungary',
		fr: 'Hongrie',
		iso2: 'HU',
		iso3: 'HUN',
		dialCode: '36'
	},
	{
		es: 'India',
		en: 'India',
		fr: 'Inde',
		iso2: 'IN',
		iso3: 'IND',
		dialCode: '91'
	},
	{
		es: 'Indonesia',
		en: 'Indonesia',
		fr: 'Indonésie',
		iso2: 'ID',
		iso3: 'IDN',
		dialCode: '62'
	},
	{
		es: 'Irán',
		en: 'Iran',
		fr: 'Iran',
		iso2: 'IR',
		iso3: 'IRN',
		dialCode: '98'
	},
	{
		es: 'Irak',
		en: 'Iraq',
		fr: 'Irak',
		iso2: 'IQ',
		iso3: 'IRQ',
		dialCode: '964'
	},
	{
		es: 'Irlanda',
		en: 'Ireland',
		fr: 'Irlande',
		iso2: 'IE',
		iso3: 'IRL',
		dialCode: '353'
	},
	{
		es: 'Isla Bouvet',
		en: 'Bouvet Island',
		fr: 'Bouvet Island',
		iso2: 'BV',
		iso3: 'BVT',
		dialCode: '47'
	},
	{
		es: 'Isla de Man',
		en: 'Isle of Man',
		fr: 'Ile de Man',
		iso2: 'IM',
		iso3: 'IMN',
		dialCode: '44'
	},
	{
		es: 'Isla de Navidad',
		en: 'Christmas Island',
		fr: 'Christmas Island',
		iso2: 'CX',
		iso3: 'CXR',
		dialCode: '61'
	},
	{
		es: 'Isla Norfolk',
		en: 'Norfolk Island',
		fr: 'Île de Norfolk',
		iso2: 'NF',
		iso3: 'NFK',
		dialCode: '672'
	},
	{
		es: 'Islandia',
		en: 'Iceland',
		fr: 'Islande',
		iso2: 'IS',
		iso3: 'ISL',
		dialCode: '354'
	},
	{
		es: 'Islas Bermudas',
		en: 'Bermuda Islands',
		fr: 'Bermudes',
		iso2: 'BM',
		iso3: 'BMU',
		dialCode: '1441'
	},
	{
		es: 'Islas Caimán',
		en: 'Cayman Islands',
		fr: 'Iles Caïmans',
		iso2: 'KY',
		iso3: 'CYM',
		dialCode: '1345'
	},
	{
		es: 'Islas Cocos (Keeling)',
		en: 'Cocos (Keeling) Islands',
		fr: 'Cocos (Keeling',
		iso2: 'CC',
		iso3: 'CCK',
		dialCode: '61'
	},
	{
		es: 'Islas Cook',
		en: 'Cook Islands',
		fr: 'Iles Cook',
		iso2: 'CK',
		iso3: 'COK',
		dialCode: '682'
	},
	{
		es: 'Islas de Åland',
		en: 'Åland Islands',
		fr: 'Îles Åland',
		iso2: 'AX',
		iso3: 'ALA',
		dialCode: '358'
	},
	{
		es: 'Islas Feroe',
		en: 'Faroe Islands',
		fr: 'Iles Féro',
		iso2: 'FO',
		iso3: 'FRO',
		dialCode: '298'
	},
	{
		es: 'Islas Georgias del Sur y Sandwich del Sur',
		en: 'South Georgia and the South Sandwich Islands',
		fr: 'Géorgie du Sud et les Îles Sandwich du Sud',
		iso2: 'GS',
		iso3: 'SGS',
		dialCode: '500'
	},
	{
		es: 'Islas Heard y McDonald',
		en: 'Heard Island and McDonald Islands',
		fr: 'Les îles Heard et McDonald',
		iso2: 'HM',
		iso3: 'HMD',
		dialCode: '0'
	},
	{
		es: 'Islas Maldivas',
		en: 'Maldives',
		fr: 'Maldives',
		iso2: 'MV',
		iso3: 'MDV',
		dialCode: '960'
	},
	{
		es: 'Islas Malvinas',
		en: 'Falkland Islands (Malvinas)',
		fr: 'Iles Falkland (Malvinas',
		iso2: 'FK',
		iso3: 'FLK',
		dialCode: '500'
	},
	{
		es: 'Islas Marianas del Norte',
		en: 'Northern Mariana Islands',
		fr: 'Iles Mariannes du Nord',
		iso2: 'MP',
		iso3: 'MNP',
		dialCode: '1670'
	},
	{
		es: 'Islas Marshall',
		en: 'Marshall Islands',
		fr: 'Iles Marshall',
		iso2: 'MH',
		iso3: 'MHL',
		dialCode: '692'
	},
	{
		es: 'Islas Pitcairn',
		en: 'Pitcairn Islands',
		fr: 'Iles Pitcairn',
		iso2: 'PN',
		iso3: 'PCN',
		dialCode: '870'
	},
	{
		es: 'Islas Salomón',
		en: 'Solomon Islands',
		fr: 'Iles Salomon',
		iso2: 'SB',
		iso3: 'SLB',
		dialCode: '677'
	},
	{
		es: 'Islas Turcas y Caicos',
		en: 'Turks and Caicos Islands',
		fr: 'Iles Turques et Caïques',
		iso2: 'TC',
		iso3: 'TCA',
		dialCode: '1649'
	},
	{
		es: 'Islas Ultramarinas Menores de Estados Unidos',
		en: 'United States Minor Outlying Islands',
		fr: 'États-Unis Îles mineures éloignées',
		iso2: 'UM',
		iso3: 'UMI',
		dialCode: '246'
	},
	{
		es: 'Islas Vírgenes Británicas',
		en: 'Virgin Islands',
		fr: 'Iles Vierges',
		iso2: 'VG',
		iso3: 'VG',
		dialCode: '1284'
	},
	{
		es: 'Islas Vírgenes de los Estados Unidos',
		en: 'United States Virgin Islands',
		fr: 'Îles Vierges américaines',
		iso2: 'VI',
		iso3: 'VIR',
		dialCode: '1340'
	},
	{
		es: 'Israel',
		en: 'Israel',
		fr: 'Israël',
		iso2: 'IL',
		iso3: 'ISR',
		dialCode: '972'
	},
	{
		es: 'Italia',
		en: 'Italy',
		fr: 'Italie',
		iso2: 'IT',
		iso3: 'ITA',
		dialCode: '39'
	},
	{
		es: 'Jamaica',
		en: 'Jamaica',
		fr: 'Jamaïque',
		iso2: 'JM',
		iso3: 'JAM',
		dialCode: '1876'
	},
	{
		es: 'Japón',
		en: 'Japan',
		fr: 'Japon',
		iso2: 'JP',
		iso3: 'JPN',
		dialCode: '81'
	},
	{
		es: 'Jersey',
		en: 'Jersey',
		fr: 'Maillot',
		iso2: 'JE',
		iso3: 'JEY',
		dialCode: '44'
	},
	{
		es: 'Jordania',
		en: 'Jordan',
		fr: 'Jordan',
		iso2: 'JO',
		iso3: 'JOR',
		dialCode: '962'
	},
	{
		es: 'Kazajistán',
		en: 'Kazakhstan',
		fr: 'Le Kazakhstan',
		iso2: 'KZ',
		iso3: 'KAZ',
		dialCode: '7'
	},
	{
		es: 'Kenia',
		en: 'Kenya',
		fr: 'Kenya',
		iso2: 'KE',
		iso3: 'KEN',
		dialCode: '254'
	},
	{
		es: 'Kirgizstán',
		en: 'Kyrgyzstan',
		fr: 'Kirghizstan',
		iso2: 'KG',
		iso3: 'KGZ',
		dialCode: '996'
	},
	{
		es: 'Kiribati',
		en: 'Kiribati',
		fr: 'Kiribati',
		iso2: 'KI',
		iso3: 'KIR',
		dialCode: '686'
	},
	{
		es: 'Kuwait',
		en: 'Kuwait',
		fr: 'Koweït',
		iso2: 'KW',
		iso3: 'KWT',
		dialCode: '965'
	},
	{
		es: 'Líbano',
		en: 'Lebanon',
		fr: 'Liban',
		iso2: 'LB',
		iso3: 'LBN',
		dialCode: '961'
	},
	{
		es: 'Laos',
		en: 'Laos',
		fr: 'Laos',
		iso2: 'LA',
		iso3: 'LAO',
		dialCode: '856'
	},
	{
		es: 'Lesoto',
		en: 'Lesotho',
		fr: 'Lesotho',
		iso2: 'LS',
		iso3: 'LSO',
		dialCode: '266'
	},
	{
		es: 'Letonia',
		en: 'Latvia',
		fr: 'La Lettonie',
		iso2: 'LV',
		iso3: 'LVA',
		dialCode: '371'
	},
	{
		es: 'Liberia',
		en: 'Liberia',
		fr: 'Liberia',
		iso2: 'LR',
		iso3: 'LBR',
		dialCode: '231'
	},
	{
		es: 'Libia',
		en: 'Libya',
		fr: 'Libye',
		iso2: 'LY',
		iso3: 'LBY',
		dialCode: '218'
	},
	{
		es: 'Liechtenstein',
		en: 'Liechtenstein',
		fr: 'Liechtenstein',
		iso2: 'LI',
		iso3: 'LIE',
		dialCode: '423'
	},
	{
		es: 'Lituania',
		en: 'Lithuania',
		fr: 'La Lituanie',
		iso2: 'LT',
		iso3: 'LTU',
		dialCode: '370'
	},
	{
		es: 'Luxemburgo',
		en: 'Luxembourg',
		fr: 'Luxembourg',
		iso2: 'LU',
		iso3: 'LUX',
		dialCode: '352'
	},
	{
		es: 'México',
		en: 'Mexico',
		fr: 'Mexique',
		iso2: 'MX',
		iso3: 'MEX',
		dialCode: '52'
	},
	{
		es: 'Mónaco',
		en: 'Monaco',
		fr: 'Monaco',
		iso2: 'MC',
		iso3: 'MCO',
		dialCode: '377'
	},
	{
		es: 'Macao',
		en: 'Macao',
		fr: 'Macao',
		iso2: 'MO',
		iso3: 'MAC',
		dialCode: '853'
	},
	{
		es: 'Macedônia',
		en: 'Macedonia',
		fr: 'Macédoine',
		iso2: 'MK',
		iso3: 'MKD',
		dialCode: '389'
	},
	{
		es: 'Madagascar',
		en: 'Madagascar',
		fr: 'Madagascar',
		iso2: 'MG',
		iso3: 'MDG',
		dialCode: '261'
	},
	{
		es: 'Malasia',
		en: 'Malaysia',
		fr: 'Malaisie',
		iso2: 'MY',
		iso3: 'MYS',
		dialCode: '60'
	},
	{
		es: 'Malawi',
		en: 'Malawi',
		fr: 'Malawi',
		iso2: 'MW',
		iso3: 'MWI',
		dialCode: '265'
	},
	{
		es: 'Mali',
		en: 'Mali',
		fr: 'Mali',
		iso2: 'ML',
		iso3: 'MLI',
		dialCode: '223'
	},
	{
		es: 'Malta',
		en: 'Malta',
		fr: 'Malte',
		iso2: 'MT',
		iso3: 'MLT',
		dialCode: '356'
	},
	{
		es: 'Marruecos',
		en: 'Morocco',
		fr: 'Maroc',
		iso2: 'MA',
		iso3: 'MAR',
		dialCode: '212'
	},
	{
		es: 'Martinica',
		en: 'Martinique',
		fr: 'Martinique',
		iso2: 'MQ',
		iso3: 'MTQ',
		dialCode: '596'
	},
	{
		es: 'Mauricio',
		en: 'Mauritius',
		fr: 'Iles Maurice',
		iso2: 'MU',
		iso3: 'MUS',
		dialCode: '230'
	},
	{
		es: 'Mauritania',
		en: 'Mauritania',
		fr: 'Mauritanie',
		iso2: 'MR',
		iso3: 'MRT',
		dialCode: '222'
	},
	{
		es: 'Mayotte',
		en: 'Mayotte',
		fr: 'Mayotte',
		iso2: 'YT',
		iso3: 'MYT',
		dialCode: '262'
	},
	{
		es: 'Micronesia',
		en: 'Estados Federados de',
		fr: 'Federados Estados de',
		iso2: 'FM',
		iso3: 'FSM',
		dialCode: '691'
	},
	{
		es: 'Moldavia',
		en: 'Moldova',
		fr: 'Moldavie',
		iso2: 'MD',
		iso3: 'MDA',
		dialCode: '373'
	},
	{
		es: 'Mongolia',
		en: 'Mongolia',
		fr: 'Mongolie',
		iso2: 'MN',
		iso3: 'MNG',
		dialCode: '976'
	},
	{
		es: 'Montenegro',
		en: 'Montenegro',
		fr: 'Monténégro',
		iso2: 'ME',
		iso3: 'MNE',
		dialCode: '382'
	},
	{
		es: 'Montserrat',
		en: 'Montserrat',
		fr: 'Montserrat',
		iso2: 'MS',
		iso3: 'MSR',
		dialCode: '1664'
	},
	{
		es: 'Mozambique',
		en: 'Mozambique',
		fr: 'Mozambique',
		iso2: 'MZ',
		iso3: 'MOZ',
		dialCode: '258'
	},
	{
		es: 'Namibia',
		en: 'Namibia',
		fr: 'Namibie',
		iso2: 'NA',
		iso3: 'NAM',
		dialCode: '264'
	},
	{
		es: 'Nauru',
		en: 'Nauru',
		fr: 'Nauru',
		iso2: 'NR',
		iso3: 'NRU',
		dialCode: '674'
	},
	{
		es: 'Nepal',
		en: 'Nepal',
		fr: 'Népal',
		iso2: 'NP',
		iso3: 'NPL',
		dialCode: '977'
	},
	{
		es: 'Nicaragua',
		en: 'Nicaragua',
		fr: 'Nicaragua',
		iso2: 'NI',
		iso3: 'NIC',
		dialCode: '505'
	},
	{
		es: 'Niger',
		en: 'Niger',
		fr: 'Niger',
		iso2: 'NE',
		iso3: 'NER',
		dialCode: '227'
	},
	{
		es: 'Nigeria',
		en: 'Nigeria',
		fr: 'Nigeria',
		iso2: 'NG',
		iso3: 'NGA',
		dialCode: '234'
	},
	{
		es: 'Niue',
		en: 'Niue',
		fr: 'Niou',
		iso2: 'NU',
		iso3: 'NIU',
		dialCode: '683'
	},
	{
		es: 'Noruega',
		en: 'Norway',
		fr: 'Norvège',
		iso2: 'NO',
		iso3: 'NOR',
		dialCode: '47'
	},
	{
		es: 'Nueva Caledonia',
		en: 'New Caledonia',
		fr: 'Nouvelle-Calédonie',
		iso2: 'NC',
		iso3: 'NCL',
		dialCode: '687'
	},
	{
		es: 'Nueva Zelanda',
		en: 'New Zealand',
		fr: 'Nouvelle-Zélande',
		iso2: 'NZ',
		iso3: 'NZL',
		dialCode: '64'
	},
	{
		es: 'Omán',
		en: 'Oman',
		fr: 'Oman',
		iso2: 'OM',
		iso3: 'OMN',
		dialCode: '968'
	},
	{
		es: 'Países Bajos',
		en: 'Netherlands',
		fr: 'Pays-Bas',
		iso2: 'NL',
		iso3: 'NLD',
		dialCode: '31'
	},
	{
		es: 'Pakistán',
		en: 'Pakistan',
		fr: 'Pakistan',
		iso2: 'PK',
		iso3: 'PAK',
		dialCode: '92'
	},
	{
		es: 'Palau',
		en: 'Palau',
		fr: 'Palau',
		iso2: 'PW',
		iso3: 'PLW',
		dialCode: '680'
	},
	{
		es: 'Palestina',
		en: 'Palestine',
		fr: 'La Palestine',
		iso2: 'PS',
		iso3: 'PSE',
		dialCode: '970'
	},
	{
		es: 'Panamá',
		en: 'Panama',
		fr: 'Panama',
		iso2: 'PA',
		iso3: 'PAN',
		dialCode: '507'
	},
	{
		es: 'Papúa Nueva Guinea',
		en: 'Papua New Guinea',
		fr: 'Papouasie-Nouvelle-Guinée',
		iso2: 'PG',
		iso3: 'PNG',
		dialCode: '675'
	},
	{
		es: 'Paraguay',
		en: 'Paraguay',
		fr: 'Paraguay',
		iso2: 'PY',
		iso3: 'PRY',
		dialCode: '595'
	},
	{
		es: 'Perú',
		en: 'Peru',
		fr: 'Pérou',
		iso2: 'PE',
		iso3: 'PER',
		dialCode: '51'
	},
	{
		es: 'Polinesia Francesa',
		en: 'French Polynesia',
		fr: 'Polynésie française',
		iso2: 'PF',
		iso3: 'PYF',
		dialCode: '689'
	},
	{
		es: 'Polonia',
		en: 'Poland',
		fr: 'Pologne',
		iso2: 'PL',
		iso3: 'POL',
		dialCode: '48'
	},
	{
		es: 'Portugal',
		en: 'Portugal',
		fr: 'Portugal',
		iso2: 'PT',
		iso3: 'PRT',
		dialCode: '351'
	},
	{
		es: 'Puerto Rico',
		en: 'Puerto Rico',
		fr: 'Porto Rico',
		iso2: 'PR',
		iso3: 'PRI',
		dialCode: '1'
	},
	{
		es: 'Qatar',
		en: 'Qatar',
		fr: 'Qatar',
		iso2: 'QA',
		iso3: 'QAT',
		dialCode: '974'
	},
	{
		es: 'Reino Unido',
		en: 'United Kingdom',
		fr: 'Royaume-Uni',
		iso2: 'GB',
		iso3: 'GBR',
		dialCode: '44'
	},
	{
		es: 'República Centroafricana',
		en: 'Central African Republic',
		fr: 'République Centrafricaine',
		iso2: 'CF',
		iso3: 'CAF',
		dialCode: '236'
	},
	{
		es: 'República Checa',
		en: 'Czech Republic',
		fr: 'République Tchèque',
		iso2: 'CZ',
		iso3: 'CZE',
		dialCode: '420'
	},
	{
		es: 'República Dominicana',
		en: 'Dominican Republic',
		fr: 'République Dominicaine',
		iso2: 'DO',
		iso3: 'DOM',
		dialCode: '1809'
	},
	{
		es: 'Reunión',
		en: 'Réunion',
		fr: 'Réunion',
		iso2: 'RE',
		iso3: 'REU',
		dialCode: '262'
	},
	{
		es: 'Ruanda',
		en: 'Rwanda',
		fr: 'Rwanda',
		iso2: 'RW',
		iso3: 'RWA',
		dialCode: '250'
	},
	{
		es: 'Rumanía',
		en: 'Romania',
		fr: 'Roumanie',
		iso2: 'RO',
		iso3: 'ROU',
		dialCode: '40'
	},
	{
		es: 'Rusia',
		en: 'Russia',
		fr: 'La Russie',
		iso2: 'RU',
		iso3: 'RUS',
		dialCode: '7'
	},
	{
		es: 'Sahara Occidental',
		en: 'Western Sahara',
		fr: 'Sahara Occidental',
		iso2: 'EH',
		iso3: 'ESH',
		dialCode: '212'
	},
	{
		es: 'Samoa',
		en: 'Samoa',
		fr: 'Samoa',
		iso2: 'WS',
		iso3: 'WSM',
		dialCode: '685'
	},
	{
		es: 'Samoa Americana',
		en: 'American Samoa',
		fr: 'Les Samoa américaines',
		iso2: 'AS',
		iso3: 'ASM',
		dialCode: '1684'
	},
	{
		es: 'San Bartolomé',
		en: 'Saint Barthélemy',
		fr: 'Saint-Barthélemy',
		iso2: 'BL',
		iso3: 'BLM',
		dialCode: '590'
	},
	{
		es: 'San Cristóbal y Nieves',
		en: 'Saint Kitts and Nevis',
		fr: 'Saint Kitts et Nevis',
		iso2: 'KN',
		iso3: 'KNA',
		dialCode: '1869'
	},
	{
		es: 'San Marino',
		en: 'San Marino',
		fr: 'San Marino',
		iso2: 'SM',
		iso3: 'SMR',
		dialCode: '378'
	},
	{
		es: 'San Martín (Francia)',
		en: 'Saint Martin (French part)',
		fr: 'Saint-Martin (partie française)',
		iso2: 'MF',
		iso3: 'MAF',
		dialCode: '1599'
	},
	{
		es: 'San Pedro y Miquelón',
		en: 'Saint Pierre and Miquelon',
		fr: 'Saint-Pierre-et-Miquelon',
		iso2: 'PM',
		iso3: 'SPM',
		dialCode: '508'
	},
	{
		es: 'San Vicente y las Granadinas',
		en: 'Saint Vincent and the Grenadines',
		fr: 'Saint-Vincent et Grenadines',
		iso2: 'VC',
		iso3: 'VCT',
		dialCode: '1784'
	},
	{
		es: 'Santa Elena',
		en: 'Ascensión y Tristán de Acuña',
		fr: 'Ascensión y Tristan de Acuña',
		iso2: 'SH',
		iso3: 'SHN',
		dialCode: '290'
	},
	{
		es: 'Santa Lucía',
		en: 'Saint Lucia',
		fr: 'Sainte-Lucie',
		iso2: 'LC',
		iso3: 'LCA',
		dialCode: '1758'
	},
	{
		es: 'Santo Tomé y Príncipe',
		en: 'Sao Tome and Principe',
		fr: 'Sao Tomé et Principe',
		iso2: 'ST',
		iso3: 'STP',
		dialCode: '239'
	},
	{
		es: 'Senegal',
		en: 'Senegal',
		fr: 'Sénégal',
		iso2: 'SN',
		iso3: 'SEN',
		dialCode: '221'
	},
	{
		es: 'Serbia',
		en: 'Serbia',
		fr: 'Serbie',
		iso2: 'RS',
		iso3: 'SRB',
		dialCode: '381'
	},
	{
		es: 'Seychelles',
		en: 'Seychelles',
		fr: 'Les Seychelles',
		iso2: 'SC',
		iso3: 'SYC',
		dialCode: '248'
	},
	{
		es: 'Sierra Leona',
		en: 'Sierra Leone',
		fr: 'Sierra Leone',
		iso2: 'SL',
		iso3: 'SLE',
		dialCode: '232'
	},
	{
		es: 'Singapur',
		en: 'Singapore',
		fr: 'Singapour',
		iso2: 'SG',
		iso3: 'SGP',
		dialCode: '65'
	},
	{
		es: 'Siria',
		en: 'Syria',
		fr: 'Syrie',
		iso2: 'SY',
		iso3: 'SYR',
		dialCode: '963'
	},
	{
		es: 'Somalia',
		en: 'Somalia',
		fr: 'Somalie',
		iso2: 'SO',
		iso3: 'SOM',
		dialCode: '252'
	},
	{
		es: 'Sri lanka',
		en: 'Sri Lanka',
		fr: 'Sri Lanka',
		iso2: 'LK',
		iso3: 'LKA',
		dialCode: '94'
	},
	{
		es: 'Sudáfrica',
		en: 'South Africa',
		fr: 'Afrique du Sud',
		iso2: 'ZA',
		iso3: 'ZAF',
		dialCode: '27'
	},
	{
		es: 'Sudán',
		en: 'Sudan',
		fr: 'Soudan',
		iso2: 'SD',
		iso3: 'SDN',
		dialCode: '249'
	},
	{
		es: 'Suecia',
		en: 'Sweden',
		fr: 'Suède',
		iso2: 'SE',
		iso3: 'SWE',
		dialCode: '46'
	},
	{
		es: 'Suiza',
		en: 'Switzerland',
		fr: 'Suisse',
		iso2: 'CH',
		iso3: 'CHE',
		dialCode: '41'
	},
	{
		es: 'Surinám',
		en: 'Surien',
		fr: 'Surinam',
		iso2: 'SR',
		iso3: 'SUR',
		dialCode: '597'
	},
	{
		es: 'Svalbard y Jan Mayen',
		en: 'Svalbard and Jan Mayen',
		fr: 'Svalbard et Jan Mayen',
		iso2: 'SJ',
		iso3: 'SJM',
		dialCode: '47'
	},
	{
		es: 'Swazilandia',
		en: 'Swaziland',
		fr: 'Swaziland',
		iso2: 'SZ',
		iso3: 'SWZ',
		dialCode: '268'
	},
	{
		es: 'Tadjikistán',
		en: 'Tajikistan',
		fr: 'Le Tadjikistan',
		iso2: 'TJ',
		iso3: 'TJK',
		dialCode: '992'
	},
	{
		es: 'Tailandia',
		en: 'Thailand',
		fr: 'Thaïlande',
		iso2: 'TH',
		iso3: 'THA',
		dialCode: '66'
	},
	{
		es: 'Taiwán',
		en: 'Taiwan',
		fr: 'Taiwan',
		iso2: 'TW',
		iso3: 'TWN',
		dialCode: '886'
	},
	{
		es: 'Tanzania',
		en: 'Tanzania',
		fr: 'Tanzanie',
		iso2: 'TZ',
		iso3: 'TZA',
		dialCode: '255'
	},
	{
		es: 'Territorio Británico del Océano Índico',
		en: 'British Indian Ocean Territory',
		fr: "Territoire britannique de l'océan Indien",
		iso2: 'IO',
		iso3: 'IOT',
		dialCode: '246'
	},
	{
		es: 'Territorios Australes y Antárticas Franceses',
		en: 'French Southern Territories',
		fr: 'Terres australes françaises',
		iso2: 'TF',
		iso3: 'ATF',
		dialCode: '262'
	},
	{
		es: 'Timor Oriental',
		en: 'East Timor',
		fr: 'Timor-Oriental',
		iso2: 'TL',
		iso3: 'TLS',
		dialCode: '670'
	},
	{
		es: 'Togo',
		en: 'Togo',
		fr: 'Togo',
		iso2: 'TG',
		iso3: 'TGO',
		dialCode: '228'
	},
	{
		es: 'Tokelau',
		en: 'Tokelau',
		fr: 'Tokélaou',
		iso2: 'TK',
		iso3: 'TKL',
		dialCode: '690'
	},
	{
		es: 'Tonga',
		en: 'Tonga',
		fr: 'Tonga',
		iso2: 'TO',
		iso3: 'TON',
		dialCode: '676'
	},
	{
		es: 'Trinidad y Tobago',
		en: 'Trinidad and Tobago',
		fr: 'Trinidad et Tobago',
		iso2: 'TT',
		iso3: 'TTO',
		dialCode: '1868'
	},
	{
		es: 'Tunez',
		en: 'Tunisia',
		fr: 'Tunisie',
		iso2: 'TN',
		iso3: 'TUN',
		dialCode: '216'
	},
	{
		es: 'Turkmenistán',
		en: 'Turkmenistan',
		fr: 'Le Turkménistan',
		iso2: 'TM',
		iso3: 'TKM',
		dialCode: '993'
	},
	{
		es: 'Turquía',
		en: 'Turkey',
		fr: 'Turquie',
		iso2: 'TR',
		iso3: 'TUR',
		dialCode: '90'
	},
	{
		es: 'Tuvalu',
		en: 'Tuvalu',
		fr: 'Tuvalu',
		iso2: 'TV',
		iso3: 'TUV',
		dialCode: '688'
	},
	{
		es: 'Ucrania',
		en: 'Ukraine',
		fr: "L'Ukraine",
		iso2: 'UA',
		iso3: 'UKR',
		dialCode: '380'
	},
	{
		es: 'Uganda',
		en: 'Uganda',
		fr: 'Ouganda',
		iso2: 'UG',
		iso3: 'UGA',
		dialCode: '256'
	},
	{
		es: 'Uruguay',
		en: 'Uruguay',
		fr: 'Uruguay',
		iso2: 'UY',
		iso3: 'URY',
		dialCode: '598'
	},
	{
		es: 'Uzbekistán',
		en: 'Uzbekistan',
		fr: "L'Ouzbékistan",
		iso2: 'UZ',
		iso3: 'UZB',
		dialCode: '998'
	},
	{
		es: 'Vanuatu',
		en: 'Vanuatu',
		fr: 'Vanuatu',
		iso2: 'VU',
		iso3: 'VUT',
		dialCode: '678'
	},
	{
		es: 'Venezuela',
		en: 'Venezuela',
		fr: 'Venezuela',
		iso2: 'VE',
		iso3: 'VEN',
		dialCode: '58'
	},
	{
		es: 'Vietnam',
		en: 'Vietnam',
		fr: 'Vietnam',
		iso2: 'VN',
		iso3: 'VNM',
		dialCode: '84'
	},
	{
		es: 'Wallis y Futuna',
		en: 'Wallis and Futuna',
		fr: 'Wallis et Futuna',
		iso2: 'WF',
		iso3: 'WLF',
		dialCode: '681'
	},
	{
		es: 'Yemen',
		en: 'Yemen',
		fr: 'Yémen',
		iso2: 'YE',
		iso3: 'YEM',
		dialCode: '967'
	},
	{
		es: 'Yibuti',
		en: 'Djibouti',
		fr: 'Djibouti',
		iso2: 'DJ',
		iso3: 'DJI',
		dialCode: '253'
	},
	{
		es: 'Zambia',
		en: 'Zambia',
		fr: 'Zambie',
		iso2: 'ZM',
		iso3: 'ZMB',
		dialCode: '260'
	},
	{
		es: 'Zimbabue',
		en: 'Zimbabwe',
		fr: 'Zimbabwe',
		iso2: 'ZW',
		iso3: 'ZWE',
		dialCode: '263'
	}
];

export default countries;
